export default {
  header: 'Voorraad per product',
  release: 'Vrijgeven',
  empty: 'Geen AGP-records.',
  product: 'Product',
  bottleSize: 'Flesgrootte',
  inAgp: 'In AGP',
  bottled: 'Gebotteld',
  released: 'Vrijgegeven',
  batches: 'Batches',
  emptyBatch: 'leeg',
};
